import { type ReactNode, useEffect } from 'react';

export default function ConfirmDialog({
  title, subtitle, children, confirmLabel, cancelLabel = 'Go back', busy, focusConfirm = true,
  confirmDisabled = false, onConfirm, onCancel,
}: {
  title: string;
  subtitle?: string;
  children?: ReactNode;
  confirmLabel: string;
  cancelLabel?: string;
  busy?: boolean;
  focusConfirm?: boolean;
  confirmDisabled?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape' && !busy) onCancel(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [busy, onCancel]);

  return (
    <div className="backdrop" style={{ zIndex: 50 }} onClick={() => { if (!busy) onCancel(); }}>
      <div className="modal" role="dialog" aria-modal="true" aria-label={title} style={{ width: 480 }}
           onClick={(e) => e.stopPropagation()}>
        <div className="modal-head">
          <h3>{title}</h3>
          {subtitle && <p>{subtitle}</p>}
        </div>
        {children && <div className="modal-body">{children}</div>}
        <div className="modal-foot">
          <button className="btn" onClick={onCancel} disabled={busy}>{cancelLabel}</button>
          <button className="btn primary" autoFocus={focusConfirm} onClick={onConfirm} disabled={busy || confirmDisabled}>
            {busy ? 'Saving…' : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
